import { Heading, Paragraph } from '@zillow/constellation-10';
type PageTitleProps = {
  heading: string;
  subheading?: string;
};

export default function PageHeading({ heading, subheading }: PageTitleProps) {
  return (
    <>
      <Heading level={1} fontFamily="heading-alt" css={{ textStyle: { xlDown: 'h4', xl: 'h3' } }}>
        {heading}
      </Heading>

      {subheading && <Paragraph textStyle="body">{subheading}</Paragraph>}
    </>
  );
}
